import React, {FC} from "react"

import Flex from "@irati/ui/src/Flex"
import {H4, Body} from "@irati/ui/src/Typography"
import FormattedMessage from "@irati/utils/lang"
import Spacing from "@irati/ui/src/Spacing"

import {Img} from "./styled"

interface Props {
  title?: string
  text: string
  img: string
  alt: string
  alignItems: any
  height: number
}

const Content: FC<Props> = ({title, text, img, alt, alignItems, height}) => {
  return (
    <Flex flex="1" alignItems={alignItems} minWidth="300px">
      <Img src={img} alt={alt} height={height} />
      <Spacing marginLeft={2}>
        {title && (
          <H4 marginBottom={2}>
            <FormattedMessage id={title} />
          </H4>
        )}
        <Body small>
          <FormattedMessage id={text} />
        </Body>
      </Spacing>
    </Flex>
  )
}

export default Content
